import styled from "react-emotion";

const AlbumImage = styled("img")`
  object-fit: cover;
  max-width: 100%;
  width: 100%;
  vertical-align: middle;
`;

export default AlbumImage;
